import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { AiAdministrationConfiguration, AiSpendingWarning } from "./AiAdministration.types";
import { usePlanContext } from "../auth/planProvider/PlanProvider";

export function useAiAdministrationConfiguration() {
    const { addonsFeatures } = usePlanContext();

    const { data, isLoading, refetch } = useDotLegalQuery<AiAdministrationConfiguration>("/ai-administration/configuration", {
        enabled: addonsFeatures.aiFeatures,
    });

    return { data, isLoading, refetch };
}

export function useAiSpendingWarning() {
    const { addonsFeatures } = usePlanContext();

    const { data, isLoading } = useDotLegalQuery<AiSpendingWarning>("/ai-administration/spending-warning", {
        enabled: addonsFeatures.aiFeatures,
        staleTime: 60 * 1000,
    });

    return { data, isLoading };
}
